<p-confirmDialog />
<h3 class="with-manual-link">
  <span i18n="@@online-sources">Online-Quellen</span>
  <app-manual-link
  href="https://reflact.github.io/engine/Handbuch/Nutzeroberfläche/Bot-Verwaltung/Skills/Online-Quellen"></app-manual-link>
</h3>
<p
  class="text-secondary mt-1 mb-1"
  i18n="@@online-sources-description"
>
  Konfiguriere Webseiten, die beim Abruf live aufgerufen werden. Der gesamte Seiteninhalt wird dem LLM übergeben – so
  bleiben die Informationen immer aktuell.
</p>
<div>
  <div class="row">
    <div class="col-3">
      <span i18n="@@source-usage-description">Beschreibe, wofür diese Quelle verwendet wird</span>
    </div>
    <div class="col">
      <p-inputgroup>
        <p-inputgroup-addon>
          <i
            class="ri-sparkling-fill text-primary"
            style="font-size: 1.2rem;"
          ></i>
        </p-inputgroup-addon>
        <input
          pInputText
          i18n-placeholder="@@description"
          placeholder="Beschreibung"
          [(ngModel)]="this.toolDescription"
          fluid
          >
      </p-inputgroup>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-3">
      <span i18n="@@url">URL</span>
    </div>
    <div class="col">
      <input
        pInputText
        placeholder="https://"
        [(ngModel)]="this.toolUrl"
        [ngModelOptions]="{updateOn: 'change'}"
        fluid
        >
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-3">&nbsp;</div>
    <div class="col">
      <p-button
        severity="primary"
        size="small"
        [disabled]="this.checkForAdding()"
        (onClick)="this.addToolConfig()"
        >
        <i class="ri-add-line"></i>
        <span i18n="@@add">Hinzufügen</span>
      </p-button>
    </div>
  </div>
</div>

<app-secret-placeholder-list></app-secret-placeholder-list>

@if (this.toolConfigs.length > 0) {
  <h5
    class="mt-5"
    i18n="@@knowledge-from-online-sources"
  >Wissen aus Online-Quellen im Überblick</h5>
}
@if (this.toolConfigs.length > 0) {
  <p-table
    dataKey="id"
    [(selection)]="selectedToolConfigs"
    [value]="this.toolConfigs"
    [rowHover]="true"
    styleClass="p-datatable-sm"
    >
    <ng-template pTemplate="header">
      <tr>
        <th class="bot-selection-cell"><p-tableHeaderCheckbox ariaLabel="Alle auswählen" i18n-ariaLabel="@@bulk-select-all" /></th>
        <th i18n="@@status">Status</th>
        <th i18n="@@url">URL</th>
        <th i18n="@@description">Beschreibung</th>
        <th i18n="@@skillid">Skill ID</th>
        <th i18n="@@skill-usage-column">Stage-Zuordnung</th>
        <th i18n="@@onoff">Aus/An</th>
        <th i18n="@@actions">Aktionen</th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-toolConfig
      >
      <tr class="align-middle">
        <td class="bot-selection-cell"><p-tableCheckbox [value]="toolConfig" [ariaLabel]="toolConfig.url" /></td>
        <td style="width: 4rem;">
          @if (toolConfig.enabled) {
            <i
              class="ri-circle-fill text-primary"
            ></i>
          }
          @if (!toolConfig.enabled) {
            <i
              class="ri-circle-line text-secondary"
            ></i>
          }
        </td>
        <td class="text-truncate">
          <a
            class="fakelink"
            (click)="showDetailDrawer(toolConfig.id)"
            [title]="toolConfig.url"
            >
            {{ toolConfig.url | shorty:45 }}
          </a>
        </td>
        <td>{{ toolConfig.description }}</td>
        <td style="width:250px">
          <app-skill-id-input
            [value]="toolConfig.skillId"
            (changed)="toolConfig.skillId = $event; this.saveToolConfig(toolConfig)"
          ></app-skill-id-input>
        </td>
        <td>
          <app-skill-usage-list [skillId]="toolConfig.skillId"></app-skill-usage-list>
        </td>
        <td style="width: 0rem;">
          <p-toggleswitch
            [(ngModel)]="toolConfig.enabled"
            (onChange)="this.updateToolConfigItem(toolConfig.id)"
            />
        </td>
        <td
          style="width: 2rem;"
          class="text-end"
          >
          <p-menu
            #menu
            appendTo="body"
            [model]="toolContextMenu"
            [popup]="true"
          ></p-menu>
          <p-button
            (onClick)="openToolMenu($event, menu, toolConfig)"
            [rounded]="true"
            [text]="true"
            severity="secondary"
            [raised]="true"
            icon="ri ri-more-2-fill"
          ></p-button>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <app-bulk-action-bar [actions]="bulkActions" [count]="selectedToolConfigs.length" [allSelected]="allSelected"
    (selectAll)="toggleAll(true)" (clear)="selectedToolConfigs = []" />
}

@if (detailDrawer) {
  <p-drawer
    [(visible)]="this.detailDrawer"
    [position]="'right'"
    [modal]="true"
    [closeOnEscape]="true"
    styleClass="w-100 w-md-75 w-lg-50"
    >
    @if (this.selectedToolId) {
      <app-online-sources-tab-detail
        [selectedToolId]="this.selectedToolId"
        (closeDrawer)="this.detailDrawer = false"
      ></app-online-sources-tab-detail>
    }
  </p-drawer>
}
